(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return

    observer.unobserve(productRecommendationsSection)

    const url = productRecommendationsSection.dataset.url

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const div = document.createElement('div')
        div.innerHTML = text
        const recommendations = div.querySelector('#product-recommendations')
        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML
          productRecommendationsSection.classList.remove('loader-after')
        }
      })
      .catch(e => {
        console.error(e)
      })
  }

  const productRecommendationsSection = document.querySelector('#product-recommendations')

  const observer = new IntersectionObserver(handleIntersection)

  observer.observe(productRecommendationsSection)

  } catch(e) { console.error(e); }
})();
})();
